import { DeleteOutlined } from "@ant-design/icons";
import { Button, Input, Modal } from "antd";
import React, { useEffect, useState } from "react";

type Props = {
    open?: any;
    isCloseModal?: any;
    item?: any
}

const SectionModal: React.FC<Props> = ({ open, isCloseModal, item }: Props) => {
    const [dep, setDep] = useState<string>(item);

    useEffect(() => {
        setDep(item)
    }, [item]);

    const handleInputDep = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setDep(event.target.value);
    };

    const closeDepModal = (isOpen: boolean) => {
        isCloseModal()
    }

    return (
        <Modal
            title={`${item == '' ? "Добавить" : "Редактировать"} отдел`}
            open={open}
            onCancel={() => closeDepModal(false)}
            footer={item != "" && item != "Руководство" ? [
                <Button key="cancel" onClick={() => closeDepModal(false)}>
                    Отмена
                </Button>,
                <Button
                    key="link"
                    type="primary"
                    onClick={() => closeDepModal(false)}
                >
                    <DeleteOutlined />
                    Удалить
                </Button>,
                <Button
                    key="link"
                    type="primary"
                    onClick={() => closeDepModal(false)}
                >
                    Сохранить
                </Button>,
            ] : [
                <Button key="cancel" onClick={() => closeDepModal(false)}>
                    Отмена
                </Button>,
                <Button
                    key="link"
                    type="primary"
                    onClick={() => closeDepModal(false)}
                >
                    Сохранить
                </Button>,
            ]
            }
        >
            <p>Название отдела</p>
            <Input type="text"
                placeholder="Введите название отдела"
                value={dep}
                name="name"
                onChange={handleInputDep} />

        </Modal>
    )
};

export default SectionModal;
